import { Component, OnInit, OnDestroy } from '@angular/core';
import { DadosService } from '../../db/dados.service';
import { UsersService } from '../../../../models/usuarios.service';
import { Subscription } from 'rxjs';
import { DataModelComponent } from '../../../../models/data.model.component';
import { DataModel } from '../../../../models/data.model';

@Component({
    selector: 'lista-sugestoes',
    templateUrl: "lista-sugestoes.html",
    styles: [``]
})
export class ListaSugestoesComponent extends DataModelComponent<any> implements OnInit, OnDestroy {
    items : Array<any> = [];
    comentarios: Array<any>=[];
    fitemAvisar:boolean;
    dadosEvent: Subscription;
    comentario:string;
    colunas =[
        {"field":"titulo"},
        {"field":"contato"},
        {"field":"texto"}
    ];
    colunasComentarios = [
        {field:"data", fn:(x)=>{return this.getDataMsg(x)}},
        {field:"comentario", text:"Comentário"},
        {field:"usuario", text:"Autor"}
    ]

    getDataMsg( data ){
     return DataModel.toDateAge(data);
       }

    constructor(private dados:DadosService,
        private users: UsersService) { 
      super({});
        this.dadosEvent =this.dados.listaNaoEncontradosClass.changedEvent.subscribe(
           (d)=>{
         //      console.log(d);
               this.items = d;
           }
       )
       this.dados.listaNaoEncontradosClass.emit();
       


    }

    ngOnInit(): void {
        this.dados.listaNaoEncontradosClass.fornecedor = this.users.fornecedor;

     }

    ngOnDestroy(){
        this.dadosEvent.unsubscribe();
    }

    doPostItem(){
        super.doPostItem(this.item);
        this.dados.listaNaoEncontradosClass.post(this.item);
    }

    get itemAvisar(){
        return this.fitemAvisar;
    }
    set itemAvisar(x){
           /// é readonly.
    }
    doEditItem($event){
        this.fitemAvisar = $event.values.avisar;
        super.doEditItem($event);
        this.dados.listaNaoEncontradosClass.getComentarios(this.item.id,(d)=>{
            this.comentarios = d;
        }) 
        console.log($event);
     }

    enviarComentario(){
      if  (this.comentario.length>5){  
          this.dados.listaNaoEncontradosClass.comentar(this.item.id, this.comentario);  
          this.comentario = '';
      }
    }
}
